<div fxFlexFill fxLayoutAlign="center center" fxLayout="column">
    <mat-icon escCustomId="overlay_icon" *ngIf="messageType === 'info'" [svgIcon]="icon" class="icon"></mat-icon>
    <mat-spinner escCustomId="overlay_spinner" *ngIf="messageType === 'loading'" [diameter]="50" color="accent" ></mat-spinner>
    <h2 escCustomId="overlay_title">{{title}}</h2>
    <p escCustomId="overlay_message">{{message}}</p>
    <button escCustomId="overlay_btn" *ngIf="enableBtn" (click)="retry()" mat-button>{{btnMessage}}</button>
</div>